import { authRoles } from 'app/auth';
import DeviceTable from './table/DeviceTable';
import DeviceEditForm from './editform/DeviceEditForm';

export default [
	{
		path: '/device/edit/:id',
		component: DeviceEditForm,
		auth: authRoles.device
	},
	{
		path: '/device/:sessionNameParam?',
		component: DeviceTable,
		auth: authRoles.device
	}
];
